import FeatureGates, {
  ClientOptions,
  FeatureGateEnvironment,
} from '@atlaskit/feature-gate-js-client';

import { STATSIG_KEYS } from '@/constants';

// To evaluate any feature, don't directly use: FeatureGates.checkGate(feature).
// Instead, use: useFeatureGatesController() -> allowSomeFeature
export enum FeatureGate {
  ALLOW_LOW_TRAFFIC = 'tome-ui-allow-low-traffic', // demo value, not currently being used
  ALLOW_SLO_DEBUG = 'tome-ui-allow-slo-debug',
}

export const isFeatureGateEnabled = (feature: FeatureGate): boolean =>
  FeatureGates.checkGate(feature);

export const getFeatureGateOptions = (): ClientOptions => {
  const env = __DEPLOY_ENV__;
  const commonOptions = {
    targetApp: 'slo-ui_web',
  };

  switch (env) {
    case 'production':
      return {
        apiKey: STATSIG_KEYS.production,
        environment: FeatureGateEnvironment.Production,
        localMode: false,
        ...commonOptions,
      };
    case 'staging':
      return {
        apiKey: STATSIG_KEYS.staging,
        environment: FeatureGateEnvironment.Staging,
        localMode: false,
        ...commonOptions,
      };
    default:
      return {
        apiKey: STATSIG_KEYS.development,
        environment: FeatureGateEnvironment.Development,
        localMode: false,
        ...commonOptions,
      };
  }
};
